export default __webpack_public_path__ + "static/gallery-award-goldport-b9204368422bdd92c1735758ac3ebd74.jpg";